<app-patient-invoices [patientGuid]="PatientGuid"></app-patient-invoices>
<app-patient-view-subscriptions [patientGuid]="PatientGuid"></app-patient-view-subscriptions>